import * as React from 'react';
import withRoot from '../modules/withRoot';
import NavBar from '../modules/views/NavBar';
import AppFooter from '../modules/views/AppFooter';
import CtaBand from '../modules/views/CtaBand';
import PageHead from '../modules/views/PageHead';
import Philosophy from './Philosophy';
import Company from './Company';
import Area from './Area';
import PageMeta from '../modules/components/PageMeta';

function Information() {
  return (
    <React.Fragment>
      <PageMeta
        title="会社情報"
        description="飯田建築有限会社の会社概要・企業理念・対応エリア。埼玉県入間市野田に拠点を置き、埼玉県西部と東京都西多摩エリアで施工しています。"
        path="/information"
      />
      <NavBar />
      <PageHead eyebrow="Company" title="会社情報" />
      <Philosophy />
      <Company />
      <Area />
      <CtaBand />
      <AppFooter />
    </React.Fragment>
  );
}

export default withRoot(Information);
